import {
  query,
  collection,
  where,
  orderBy,
  onSnapshot
} from 'firebase/firestore';
import { Firestore } from '../Firebase';
import Sector, { sectorConverter } from '../model/Sector';

export function subscribeToSectors(
  parent: string | null,
  onNext: (sectors: Sector[]) => void,
  onError?: (error: Error) => void,
  onCompletion?: () => void,
  isPrivileged: boolean = false
) {
  const colRef = collection(Firestore, 'sectors').withConverter(sectorConverter);
  let colQuery = query(colRef, where('parent', '==', parent));

  if (!isPrivileged) {
    colQuery = query(colQuery, where('public', '==', true))
  }

  colQuery = query(colQuery, orderBy('order'));

  return (
    onSnapshot(colQuery,
      querySnapshot => onNext(querySnapshot.docs.map(doc => doc.data())),
      onError,
      onCompletion
    )
  );
}

